module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_13-012d2251e79522f0153e416f2c707c62.png";